module.exports = __webpack_public_path__ + "img/geofisica3_4-3_2048.1d4c0804.jpg";